import { BaseWebComponentRepository } from '../../../../../framework/BaseWebComponentRepository';
import { IntegrityMonitorPolicyRuleSetsSectionDataProviderFactory } from '../factory/IntegrityMonitorPolicyRuleSetsSectionDataProviderFactory';
import { IntegrityMonitorPolicyRuleSetsSectionBaseDataProvider } from '../dataProvider/IntegrityMonitorPolicyRuleSetsSectionBaseDataProvider';
import { RuleSetItem } from '../types';

export class IntegrityMonitorPolicyRuleSetsSectionRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IntegrityMonitorPolicyRuleSetsSectionDataProviderFactory;
  public dataProvider: IntegrityMonitorPolicyRuleSetsSectionBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IntegrityMonitorPolicyRuleSetsSectionDataProviderFactory(),
    });
  }

  public async getCompanyRuleSetsForPolicy(): Promise<Array<RuleSetItem>> {
    return this.dataProvider.getCompanyRuleSetsForPolicy();
  }

  public async getRuleSetsForPolicy(ruleSetIds: Array<string>): Promise<Array<RuleSetItem>> {
    return this.dataProvider.getRuleSetsForPolicy(ruleSetIds);
  }
}
